import React, { useState } from 'react';
import './AdminForms.css';

export default function AddAlbum() {
  const [formData, setFormData] = useState({
    title: '', artist: '', description: '', imagePath: '',
    price: '15.99', url: '', format: 'stream', genre: '', date: '',
  });
  const [albumCover, setAlbumCover] = useState(null);
  const [imagePreview, setImagePreview] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');
  const [loading, setLoading] = useState(false);

  function handleChange(e) {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  }

  function handleFileChange(e) {
    const file = e.target.files[0];
    if (file) {
      setAlbumCover(file);
      const reader = new FileReader();
      reader.onloadend = () => setImagePreview(reader.result);
      reader.readAsDataURL(file);
    }
  }

  async function handleSubmit(e) {
    e.preventDefault();
    setError(''); setSuccess(''); setLoading(true);
    try {
      const submitFormData = new FormData();
      Object.keys(formData).forEach((key) => submitFormData.append(key, formData[key]));
      if (albumCover) submitFormData.append('albumCover', albumCover);

      const res = await fetch('/api/newAlbum', { method: 'POST', body: submitFormData });
      const data = await res.json();

      if (data.success) {
        setSuccess(`Album "${formData.title}" added successfully!`);
        setFormData({ title: '', artist: '', description: '', imagePath: '', price: '15.99', url: '', format: 'stream', genre: '', date: '' });
        setAlbumCover(null); setImagePreview('');
      } else {
        setError(data.message || 'Failed to add album');
      }
    } catch (err) {
      setError('An error occurred while adding the album');
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="admin-form-view">
      <h1>Add New Album</h1>
      {error && <div className="admin-form-error">{error}</div>}
      {success && <div className="admin-form-success">{success}</div>}

      <form onSubmit={handleSubmit} className="admin-form">
        <div className="admin-form-field">
          <label>Album title</label>
          <input name="title" value={formData.title} onChange={handleChange} required placeholder="e.g., Astronomy: The Dubcast" />
        </div>

        <div className="admin-form-row">
          <div className="admin-form-field">
            <label>Price</label>
            <input name="price" type="number" step="0.01" value={formData.price} onChange={handleChange} required />
          </div>
          <div className="admin-form-field">
            <label>Format</label>
            <select name="format" value={formData.format} onChange={handleChange}>
              <option value="stream">Stream</option>
              <option value="download">Download</option>
              <option value="physical">Physical</option>
              <option value="vinyl">Vinyl</option>
              <option value="cd">CD</option>
            </select>
          </div>
        </div>

        <div className="admin-form-field">
          <label>Description</label>
          <textarea name="description" rows={4} value={formData.description} onChange={handleChange} placeholder="Album description, recording details, etc." />
        </div>

        <div className="admin-form-field">
          <label>Upload album cover</label>
          <input type="file" accept="image/*" onChange={handleFileChange} />
          {albumCover && <span className="admin-form-filename">Selected: {albumCover.name}</span>}
        </div>

        <div className="admin-form-or">— OR —</div>

        <div className="admin-form-field">
          <label>Image URL</label>
          <input name="imagePath" value={formData.imagePath} onChange={handleChange} placeholder="https://example.com/album-cover.jpg" />
        </div>

        {(imagePreview || formData.imagePath) && (
          <div className="admin-form-preview">
            <img src={imagePreview || formData.imagePath} alt="Album cover preview" />
          </div>
        )}

        <div className="admin-form-field">
          <label>Streaming / purchase URL</label>
          <input name="url" value={formData.url} onChange={handleChange} placeholder="https://open.spotify.com/album/..." />
        </div>

        <div className="admin-form-field">
          <label>Release date</label>
          <input name="date" type="date" value={formData.date} onChange={handleChange} />
        </div>

        <button type="submit" className="mihu-btn-primary-lg admin-form-submit" disabled={loading}>
          {loading ? 'Adding album…' : 'Add album'}
        </button>
      </form>
    </div>
  );
}
